import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {twMerge} from 'tailwind-merge';
import Button from 'components/ui/Button';
import {X} from 'lucide-react';
import {useIntl} from 'contexts/IntlContext';

const OverlayToolPanel = memo(
	({toolId, titleMessageId, icon: Icon, onClose, children, className}) => {
		const intl = useIntl();

		return (
			<div
				className={twMerge(
					'w-[380px] max-w-[calc(100vw-2rem)] overflow-hidden rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-lg',
					className,
				)}
				data-overlay-tool={toolId}
			>
				<div className="flex items-center gap-2 bg-gray-50 dark:bg-gray-900 border-b border-gray-100 dark:border-gray-800 px-3 py-1.5">
					<div className="flex items-center gap-2 min-w-0 flex-1">
						{Icon && (
							<Icon className="h-4 w-4 text-gray-500 dark:text-gray-400 shrink-0" />
						)}
						<div className="text-sm font-medium text-gray-900 dark:text-gray-100 truncate">
							{intl.formatMessage({id: titleMessageId})}
						</div>
					</div>

					<Button
						variant="ghost"
						size="sm"
						className=""
						onClick={onClose}
						aria-label={intl.formatMessage({id: 'Close'})}
					>
						<X className="size-3.5" />
					</Button>
				</div>

				<div className="p-3">{children}</div>
			</div>
		);
	},
);

OverlayToolPanel.propTypes = {
	toolId: PropTypes.string.isRequired,
	titleMessageId: PropTypes.string.isRequired,
	icon: PropTypes.any,
	onClose: PropTypes.func.isRequired,
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};

OverlayToolPanel.displayName = 'OverlayToolPanel';

export default OverlayToolPanel;
